export const RELEASED_WIDGET = '<released-widget channel-id="9890556e-c7f3-41db-b6ca-ecaa0aa4f85d"></released-widget>'
export const RELEASED_PAGE = '<released-page channel-id="4e38cef0-47d2-4f0e-ad02-64ebc73330f1"></released-page>'
